document.addEventListener('DOMContentLoaded', function() {
  // 标签页切换功能
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabPanels = document.querySelectorAll('.tab-panel');

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tabId = button.getAttribute('data-tab');

      // 更新按钮状态
      tabButtons.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
        btn.setAttribute('tabindex', '-1');
      });
      button.classList.add('active');
      button.setAttribute('aria-selected', 'true');
      button.setAttribute('tabindex', '0');

      // 更新面板状态
      tabPanels.forEach(panel => {
        panel.classList.remove('active');
        panel.setAttribute('aria-hidden', 'true');
      });
      const activePanel = document.getElementById(tabId);
      if (activePanel) {
        activePanel.classList.add('active');
        activePanel.setAttribute('aria-hidden', 'false');
      }
    });
  });

  // FAQ分类筛选功能
  const categoryButtons = document.querySelectorAll('.faq-category-button');
  const faqItems = document.querySelectorAll('.faq-item');

  categoryButtons.forEach(button => {
    button.addEventListener('click', () => {
      const category = button.getAttribute('data-category');

      // 更新按钮状态
      categoryButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      // 筛选FAQ项目
      faqItems.forEach(item => {
        const itemCategory = item.getAttribute('data-category');
        if (category === 'all' || category === itemCategory) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });
    });
  });

  // 键盘导航支持
  tabButtons.forEach((button, index) => {
    button.addEventListener('keydown', (e) => {
      let targetButton;

      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          targetButton = tabButtons[index - 1] || tabButtons[tabButtons.length - 1];
          break;
        case 'ArrowRight':
          e.preventDefault();
          targetButton = tabButtons[index + 1] || tabButtons[0];
          break;
        case 'Home':
          e.preventDefault();
          targetButton = tabButtons[0];
          break;
        case 'End':
          e.preventDefault();
          targetButton = tabButtons[tabButtons.length - 1];
          break;
        default:
          return;
      }

      targetButton.click();
      targetButton.focus();
    });
  });
});